module.exports = __webpack_public_path__ + "img/8.b67ea139.jpeg";